import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FLEX_EMULATOR_SESSION_CHANGED_EVENT, captureFlexEmulatorSession, isFlexEmulatorSession } from "./session";

/**
 * Reactive emulator-session state. Captures `?flexEmulator=true` into
 * sessionStorage on navigation, follows explicit avatar-menu toggles, and
 * re-renders gated components when a session activates. Always false outside
 * DEV builds.
 */
export default function useFlexEmulatorSession(): boolean {
  const location = useLocation();
  const [active, setActive] = useState<boolean>(() => isFlexEmulatorSession());

  useEffect(() => {
    // Read the live URL, not react-router's location: toggling the session off
    // strips the param via replaceState, which doesn't update the router.
    const sync = () => setActive(captureFlexEmulatorSession(window.location.search));
    sync();
    window.addEventListener(FLEX_EMULATOR_SESSION_CHANGED_EVENT, sync);
    window.addEventListener("storage", sync);

    return () => {
      window.removeEventListener(FLEX_EMULATOR_SESSION_CHANGED_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, [location.search]);

  return active;
}
